import { useState } from 'react';
import styled from 'styled-components';

import { Flex } from '@/components/base';
import TitleInput from '@/components/Inputs/TitleInput';
import Heading from '@/components/Typography/Heading';
import useColor from '@/hooks/domain/useColor';
import { isEmptyString } from '@/utils/util';

type Props = {
  title: string;
  updateTitle: (title: string) => void;
  width?: number;
};

const TitleEditor = (props: Props) => {
  const color = useColor();
  const [editMode, setEditMode] = useState(false);
  const [value, setValue] = useState(props.title);

  return editMode ? (
    <TitleInput
      autoFocus
      value={value}
      onChange={(e) => setValue(e.target.value)}
      placeholder="Type title..."
      sizeType="m"
      style={{
        fontSize: 24,
        backgroundColor: color.gray100,
        width: props.width || 'auto',
        flex: 1,
      }}
      onBlur={() => {
        if (isEmptyString(value)) {
          setValue(props.title);
          setEditMode(false);
          return;
        }
        props.updateTitle(value);
        setEditMode(false);
      }}
    />
  ) : (
    <Style
      g={12}
      a="flex-end"
      onClick={() => setEditMode(true)}
      style={{
        width: props.width || 'fit-content',
      }}
    >
      <Heading type="h2" multilineEllipsis={1}>
        {value}
      </Heading>
    </Style>
  );
};

const Style = styled(Flex)`
  border: 1px solid transparent;
  padding: 4px 12px;
  border-radius: ${(props) => props.theme.radius.token.sm}px;
  transition: all 0.2s;
  &:hover {
    background-color: ${(props) => props.theme.colors.gray200};
    border-color: ${(props) => props.theme.colors.gray500};
  }
`;

export default TitleEditor;
